import styled, { css } from "styled-components";

const AddElementStyled = styled.div`
  cursor: pointer;
  p {
    font-size: 1.4rem;
    span {
      padding-right: 0.5rem;
    }
  }
  /* focused */
  ${props => {
    return (
      props.active &&
      css`
        background: ${props => props.theme.lighterGreen};
      `
    );
  }}
`;

export default AddElementStyled;
